import { render, staticRenderFns } from "./TeacherHeaderModule.vue?vue&type=template&id=3cd57f93&scoped=true"
import script from "./TeacherHeaderModule.vue?vue&type=script&lang=js"
export * from "./TeacherHeaderModule.vue?vue&type=script&lang=js"
import style0 from "./TeacherHeaderModule.vue?vue&type=style&index=0&id=3cd57f93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd57f93",
  null
  
)

export default component.exports